import {
  CanopyPayload,
  CanopyResponse,
  StripePayload,
  StripeResponse,
} from "api/types";
import customAxios from "config";
import toast from "react-hot-toast";
import { renterError } from "utils/errorMessage";

export const CreateCanopyVerification = async (
  payload: CanopyPayload
): Promise<{ data?: CanopyResponse; error?: string }> => {
  try {
    const response = await customAxios.post<CanopyResponse>(
      "/api/canopy/create-insurance-verification-link/",
      payload
    );

    return response;
  } catch (error: any) {
    // Was `toast.error(error.response?.data.error)` — raw server text, and an
    // empty toast whenever the response had no `error` key.
    const message = renterError(error, "insurance");
    toast.error(message);
    return { error: message };
  }
};
